import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxPaginationModule } from "ngx-pagination";
import { AlertsModule } from "src/app/Components/alerts/alerts.module";

import { ProductDetailsPipePipe } from "../product-details/product-details/product-details-pipe.pipe";
import { ProductFilterComponent } from "./product-filter/product-filter.component";
import { ProductFilterService } from "./product-filter/product-filter.service";
import { ProductListComponent } from "./product-list/product-list.component";
import { SharedVariantsModule } from "./product-list/shared-variants/shared-variants.module";
import { ProductListingComponent } from "./product-listing/product-listing.component";
import { ProductListingService } from "./product-listing/product-listing.service";
import { ProductsListPageRoutingModule } from "./products-list-page.routing.module";
import { Ng5SliderModule } from 'ng5-slider';
@NgModule ({
    declarations:[
        ProductFilterComponent,
        ProductListingComponent,
        ProductDetailsPipePipe,
        ProductListComponent,
    ],

    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        AlertsModule,
        NgxPaginationModule,
        ProductsListPageRoutingModule,
        SharedVariantsModule,
        Ng5SliderModule
    ],

    exports: [],

    providers: [
        ProductFilterService,
        ProductListingService,
    ]
})

export class ProductsListPageModule { };